import _Typography from "@mui/material/Typography";
import _Box from "@mui/material/Box";
import React from 'react';
import { useTranslation } from 'react-i18next';
import homeWorkJourneyIllustration from '../../assets/images/cyclist-illus.svg';
import firstJourneyIllustration from '../../assets/images/hourra-illus.svg';
import distanceIllustration from '../../assets/images/journeys-illus.svg';
import sponsorshipIllustration from '../../assets/images/life-illus.svg';
const wayToEarnPoints = ['sponsorship', 'firstJourney', 'distance', 'homeWorkJourney'];
const wayToEarnPointsMap = {
  sponsorship: {
    icon: sponsorshipIllustration,
    titleKey: 'commons.challenges.bttf_faq.points.sponsorship.title',
    descriptionKey: 'commons.challenges.bttf_faq.points.sponsorship.description',
    valueKey: 'commons.stats.points',
    count: 50
  },
  firstJourney: {
    icon: firstJourneyIllustration,
    titleKey: 'commons.challenges.bttf_faq.points.first_journey.title',
    descriptionKey: 'commons.challenges.bttf_faq.points.first_journey.description',
    valueKey: 'commons.stats.points',
    count: 50
  },
  distance: {
    icon: distanceIllustration,
    titleKey: 'commons.challenges.bttf_faq.points.distance.title',
    descriptionKey: 'commons.challenges.bttf_faq.points.distance.description',
    valueKey: 'commons.stats.points_per_km',
    count: 1
  },
  homeWorkJourney: {
    icon: homeWorkJourneyIllustration,
    titleKey: 'commons.challenges.bttf_faq.points.home_work_journey.title',
    descriptionKey: 'commons.challenges.bttf_faq.points.home_work_journey.description',
    value: 'x 3'
  }
};
function BttfPointsRules() {
  return /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexDirection: "column",
    gap: 2,
    sx: {
      containerType: 'inline-size'
    }
  }, wayToEarnPoints.map(key => /*#__PURE__*/React.createElement(PointsCard, {
    key: key,
    wayToEarnPointsKey: key
  })));
}
function PointsCard({
  wayToEarnPointsKey
}) {
  const {
    t
  } = useTranslation();
  const {
    titleKey,
    descriptionKey,
    icon,
    ...props
  } = wayToEarnPointsMap[wayToEarnPointsKey];
  return /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    bgcolor: "#f3f6ff",
    borderRadius: 4,
    display: "flex",
    gap: 2,
    padding: 3
  }, /*#__PURE__*/React.createElement(_Box, {
    alignItems: {
      '@': 'flex-start',
      '@500': 'center'
    },
    display: "flex",
    flexDirection: {
      '@': 'column',
      '@500': 'row'
    },
    flexGrow: 1,
    gap: 2
  }, /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    bgcolor: "#fff",
    borderRadius: 8,
    display: "flex",
    flexShrink: 0,
    height: 64,
    justifyContent: "center",
    width: 64
  }, /*#__PURE__*/React.createElement("img", {
    src: icon,
    width: 48
  })), /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    gap: 1
  }, /*#__PURE__*/React.createElement(_Typography, {
    fontWeight: 700
  }, t(titleKey)), /*#__PURE__*/React.createElement(_Typography, {
    variant: "body2"
  }, t(descriptionKey)))), /*#__PURE__*/React.createElement(_Box, {
    flexShrink: 0
  }, /*#__PURE__*/React.createElement(_Typography, {
    noWrap: true,
    color: "#6210FF",
    fontWeight: 700
  }, 'value' in props ? props.value : t(props.valueKey, {
    count: props.count
  }))));
}
export default BttfPointsRules;